import type { SchemaBuilderFieldTypePickerOptions } from "./schema-builder-field-type-picker.type";
import type { SelectProps } from "antd";

import { useTranslation } from "react-i18next";

import { useSchemaBuilderFormContext } from "@/modules/schema-builder/schema-builder-form";

import {
  getSchemaBuilderAllFieldTypes,
  getSchemaBuilderPickableFieldTypes,
} from "../schema-builder-field-type.helper";

export const useSchemaBuilderFieldTypePickerOptions = ({
  showAll,
}: SchemaBuilderFieldTypePickerOptions): SelectProps["options"] => {
  const { t } = useTranslation();
  const { context } = useSchemaBuilderFormContext();

  const fieldTypes = showAll
    ? getSchemaBuilderAllFieldTypes(context)
    : getSchemaBuilderPickableFieldTypes(context);

  const options = fieldTypes.map((type) => ({
    key: type,
    value: type,
    label: t(`schema:fieldType.${type}`),
  }));

  return options;
};
